import { c as _c } from "react/compiler-runtime";
import React, { useEffect, useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { Field, Form } from 'react-final-form';
import { LocalizedNameFields, PhoneInput, SelectInput, TextInput, TextareaInput } from '@/components/inputs';
import LogoLinkedIn from '@/assets/logos/socialMedia/linkedin-square.svg';
import { addPrefixToDataParams } from '@/utils/string';
import { Button, TabsButtons } from '@/components/buttons';
import { useForm } from '@formspree/react';
import CheckIcon from '@/assets/icons/heroIcons/CheckCircle.svg';
import { Link } from '@/components/links';
import { Text } from '@/components/typography';
import { LINKS } from '@/constants/links';
import { required, email, phone, pipeValidators } from '@/utils/validators';
import { logEvent } from '@/analytics/events';
import { NumericRange } from '@/types/range';
export const ContactForm = t0 => {
  const $ = _c(42);
  const {
    initialInterest,
    variant,
    job
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["career", "core"];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation(t1);
  const [interestedInCooperation, setInterestedInCooperation] = useState(true);
  let t2;
  let t3;
  if ($[1] !== initialInterest) {
    t2 = () => {
      if (initialInterest) {
        setInterestedInCooperation(true);
      }
    };
    t3 = [initialInterest];
    $[1] = initialInterest;
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  useEffect(t2, t3);
  const [state, handleSubmitForm] = useForm("moqgqoee");
  const isDetail = variant === "detail";
  if (state.succeeded) {
    let t4;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <CheckIcon className="mx-auto h-16 w-16 text-blue-500" />;
      $[4] = t4;
    } else {
      t4 = $[4];
    }
    let t5;
    if ($[5] !== t) {
      t5 = t("core:forms.success.title");
      $[5] = t;
      $[6] = t5;
    } else {
      t5 = $[6];
    }
    let t6;
    if ($[7] !== t5) {
      t6 = <h2 className="mt-8 mb-3 text-3xl font-bold">{t5}</h2>;
      $[7] = t5;
      $[8] = t6;
    } else {
      t6 = $[8];
    }
    let t7;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
      t7 = <br />;
      $[9] = t7;
    } else {
      t7 = $[9];
    }
    let t8;
    if ($[10] !== t) {
      t8 = <p><Trans t={t} i18nKey="core:forms.success.text">{t7}</Trans></p>;
      $[10] = t;
      $[11] = t8;
    } else {
      t8 = $[11];
    }
    let t9;
    if ($[12] !== t6 || $[13] !== t8) {
      t9 = <div className="rounded-xl bg-white px-4 py-6 text-center lg:rounded-4xl lg:p-12">{t4}{t6}{t8}</div>;
      $[12] = t6;
      $[13] = t8;
      $[14] = t9;
    } else {
      t9 = $[14];
    }
    return t9;
  }
  let t4;
  if ($[15] !== interestedInCooperation || $[16] !== isDetail || $[17] !== t) {
    t4 = function renderSubject() {
      if (!isDetail) {
        return t("form.variants.3");
      }
      if (interestedInCooperation) {
        return t("form.variants.1");
      }
      return t("form.variants.2");
    };
    $[15] = interestedInCooperation;
    $[16] = isDetail;
    $[17] = t;
    $[18] = t4;
  } else {
    t4 = $[18];
  }
  const renderSubject = t4;
  let t5;
  if ($[19] !== interestedInCooperation || $[20] !== isDetail || $[21] !== t) {
    t5 = isDetail && <div className="mx-auto mb-8 max-w-132"><TabsButtons id="contactFormTab" activeTab={interestedInCooperation ? 0 : 1} tabs={[{
        label: t("form.variants.1"),
        onClick: () => setInterestedInCooperation(true),
        id: 0
      }, {
        label: t("form.variants.2"),
        onClick: () => setInterestedInCooperation(false),
        id: 1
      }]} /></div>;
    $[19] = interestedInCooperation;
    $[20] = isDetail;
    $[21] = t;
    $[22] = t5;
  } else {
    t5 = $[22];
  }
  let t6;
  if ($[23] !== handleSubmitForm) {
    t6 = data => {
      logEvent("generate_lead", {
        action: "career"
      });
      setTimeout(() => {
        const formData = new FormData();
        Object.entries(data).forEach(t7 => {
          const [key, value] = t7;
          if (key === "upload") {
            if (value) {
              for (let i = 0; i < value.length; i++) {
                formData.append("upload", value[i]);
              }
            }
          } else {
            formData.append(key, value);
          }
        });
        handleSubmitForm(formData);
      });
    };
    $[23] = handleSubmitForm;
    $[24] = t6;
  } else {
    t6 = $[24];
  }
  let t7;
  if ($[25] !== renderSubject) {
    t7 = renderSubject();
    $[25] = renderSubject;
    $[26] = t7;
  } else {
    t7 = $[26];
  }
  let t8;
  if ($[27] !== job || $[28] !== t7) {
    t8 = {
      _subject: t7,
      _language: "cs",
      job
    };
    $[27] = job;
    $[28] = t7;
    $[29] = t8;
  } else {
    t8 = $[29];
  }
  let t9;
  if ($[30] !== interestedInCooperation || $[31] !== isDetail || $[32] !== state.submitting || $[33] !== t) {
    t9 = t10 => {
      const {
        handleSubmit
      } = t10;
      return <form encType="multipart/form-data" method="post" onSubmit={handleSubmit} {...addPrefixToDataParams({
        analyticsParam: "career",
        testId: "career",
        prefix: "form"
      })}><div className="mb-10 flex flex-col gap-8"><div className="flex flex-col gap-4"><p className="font-semibold">{t("form.categoties.1")}</p><LocalizedNameFields nameField={{
              name: "name",
              label: t("core:forms.fields.name"),
              validate: required
            }} surnameField={{
              name: "surname",
              label: t("core:forms.fields.surname"),
              validate: required
            }} /><Field name="email" type="email" validate={pipeValidators(required, email)}>{fieldRenderProps => <TextInput {...fieldRenderProps} label={t("core:forms.fields.email")} />}</Field><Field name="phone" type="tel" validate={pipeValidators(required, phone)}>{fieldRenderProps_0 => <PhoneInput {...fieldRenderProps_0} label={t("core:forms.fields.phone")} />}</Field></div>{!isDetail || interestedInCooperation ? <><div className="flex flex-col gap-4"><p className="font-semibold">{t("form.categoties.2")}</p><div className="flex flex-col gap-4 md:flex-row"><div className="w-full"><Field name="start_date" validate={required} initialValue="">{fieldRenderProps_1 => <TextInput {...fieldRenderProps_1} label={t("form.fields.date")} />}</Field></div><div className="w-full"><Field name="salary" validate={required} initialValue="">{fieldRenderProps_2 => <TextInput {...fieldRenderProps_2} label={t("form.fields.salary")} />}</Field></div></div><Field name="learn_about_us" initialValue="">{fieldRenderProps_3 => <TextInput {...fieldRenderProps_3} label={t("form.fields.learnAboutUs")} />}</Field>{!isDetail && <Field name="interest" initialValue="">{fieldRenderProps_4 => <SelectInput {...fieldRenderProps_4} label={t("form.fields.whichTeam.label")} hideLabel={true} options={Array.from({
                  length: 9
                }, (_, index) => {
                  const labelIndex = index + 1 as NumericRange<1, 9>;
                  const label = t(`form.fields.whichTeam.${labelIndex}`);
                  return {
                    label,
                    value: label
                  };
                })} />}</Field>}<Field name="message">{fieldRenderProps_5 => <TextareaInput {...fieldRenderProps_5} label={t("form.fields.message")} />}</Field></div><div className="flex flex-col gap-4"><p className="font-semibold">{t("form.categoties.3")}</p><Field name="linkedin" initialValue="">{fieldRenderProps_6 => <TextInput {...fieldRenderProps_6} label={t("form.fields.linkedin")} leftIcon={<LogoLinkedIn />} />}</Field><Field name="upload">{_temp}</Field></div></> : <div className="flex flex-col gap-4"><p className="font-semibold">{t("form.categoties.4")}</p><Field name="message">{fieldRenderProps_7 => <TextareaInput {...fieldRenderProps_7} label={t("core:forms.fields.message")} />}</Field></div>}</div><Text variant="p4" className="mb-6 text-center text-gray-600 lg:mb-10"><Trans t={t} i18nKey="form.conditions"><Link testId="informationMemorandum" analyticsParam="informationMemorandum" to={`${LINKS().informationMemorandum}#careerMemorandum`} /></Trans></Text><Button type="submit" analyticsParam="submitForm" testId="submitForm" variant="primary" align="center" size="lg" busy={state.submitting}>{t("core:forms.fields.submit")}</Button></form>;
    };
    $[30] = interestedInCooperation;
    $[31] = isDetail;
    $[32] = state.submitting;
    $[33] = t;
    $[34] = t9;
  } else {
    t9 = $[34];
  }
  let t10;
  if ($[35] !== t6 || $[36] !== t8 || $[37] !== t9) {
    t10 = <div className="rounded-xl bg-white px-4 py-6 lg:rounded-4xl lg:p-12"><Form onSubmit={t6} initialValues={t8} encType="multipart/form-data">{t9}</Form></div>;
    $[35] = t6;
    $[36] = t8;
    $[37] = t9;
    $[38] = t10;
  } else {
    t10 = $[38];
  }
  let t11;
  if ($[39] !== t10 || $[40] !== t5) {
    t11 = <>{t5}{t10}</>;
    $[39] = t10;
    $[40] = t5;
    $[41] = t11;
  } else {
    t11 = $[41];
  }
  return t11;
};
function _temp(t0) {
  const {
    input: t1
  } = t0;
  const {
    onChange,
    ...input
  } = t1;
  return <input {...input} value={undefined} type="file" multiple={true} id="upload" data-clarity-mask="true" accept="application/msword, application/vnd.ms-excel, application/vnd.ms-powerpoint, text/plain, application/pdf, image/*" onChange={t2 => {
    const {
      target
    } = t2;
    return onChange(target.files);
  }} className="input file:text-md p-[2px] placeholder-gray-400 file:mr-5 file:rounded-lg file:border-0 file:bg-blue-500 file:px-6 file:py-3 file:font-semibold file:text-white hover:file:cursor-pointer hover:file:bg-blue-600" />;
}